module.exports = __webpack_public_path__ + "static/media/06.ce717820.jpg";